export const getCurrenciesLoading = (state: any) => state.currencies.loading;
export const getCurrencies = (state: any) => state.currencies.data || {};
export const getCurrenciesError = (state: any) => state.currencies.error;
